/**
 * Route wrapper for /posteingang/$id. Turns the URL into props.
 *
 * Selection is local state AND mirrored to ?task=. The state is what renders, so a click
 * never waits on the router (writing ?task= alone cost ~55ms per click in jsdom); the URL
 * follows with replace:true, so the selection survives a reload and coming back from the
 * Aufgabe the title opened, without filling the history with one entry per click.
 *
 * Opening the route is what "reading" an Eingang means (B2), so the read mark is fired
 * here rather than inside the Maske: the Maske is also rendered by hosts that are not a
 * broker opening a mail, and a read mark is a statement about a person, not a render.
 */
import { useState } from 'react';
import { useNavigate, useParams } from '@tanstack/react-router';
import { eingangDetailRoute } from '../../routeTree.gen';
import { BearbeitungsMaske } from './BearbeitungsMaske';
import { useMarkEingangRead } from './hooks/useMarkEingangRead';

export function BearbeitungsMaskeScreen() {
  const { id } = useParams({ strict: false }) as { id: string };
  const search = eingangDetailRoute.useSearch();
  const navigate = useNavigate();

  // Seeded from `?task=`. `null` lets the Maske fall back to the first task, which is
  // what an Eingang opened from the Posteingang list wants.
  const [selectedTaskId, setSelectedTaskId] = useState<string | null>(search.task ?? null);

  useMarkEingangRead(id);

  function selectTask(taskId: string) {
    setSelectedTaskId(taskId);
    void navigate({
      to: '/posteingang/$id',
      params: { id },
      search: { task: taskId },
      replace: true,
    });
  }

  return (
    <BearbeitungsMaske
      commId={id}
      selectedTaskId={selectedTaskId}
      onSelectTask={selectTask}
      onClose={() => void navigate({ to: '/posteingang' })}
    />
  );
}
